<template>
  <div class="container-fluid d-flex flex-column p-0 my-home-page">
    <!-- 导航栏 -->
    <div class="container-fluid px-0 fixed-top">
      <nav class="navbar navbar-expand-lg navbar-light bg-light my-head py-0">
        <!-- <a
          class="navbar-brand font-weight-bolder my-head-logo py-0"
          href="#jumpabout"
        >
          {{ $t(`homeLink.elitego`) }}
        </a> -->
        <img
          src="../../assets/images/icons/cn-logo.png"
          alt=""
          v-if="$i18n.locale == 'zh'"
          style="margin-right: 30px"
        />
        <img
          src="../../assets/images/icons/en-logo.png"
          alt=""
          style="margin-right: 30px"
          v-else
        />
        <span class="en_title" v-if="$i18n.locale == 'zh'"
          >猎头做单交付一站式服务平台</span
        >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse my-head-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li
              class="nav-item col-3"
              v-for="(nav, ind) in navList"
              :key="ind"
              :class="{
                active: nav.id == currentNavInd,
              }"
            >
              <a
                class="nav-link nowrap px-4"
                :href="`#${nav.component}`"
                @click="loadView(nav)"
              >
                {{ $t(`homeLink.${nav.name}`) }}
              </a>
            </li>
            <!-- 语言切换 -->
            <li class="nav-item dropdown ml-5">
              <a class="nav-link" href="#">
                <div class="my-head-language">
                  <svg-icon
                    icon-class="global-icon"
                    class-name="global-icon"
                  ></svg-icon>
                  <span
                    :class="`px-2 ${$i18n.locale == 'zh' ? 'textarea' : ''}`"
                    @click="changeLangZh"
                  >
                    中文
                  </span>
                  /
                  <span
                    :class="`pl-2 ${$i18n.locale == 'en' ? 'textarea' : ''}`"
                    @click="changeLangEn"
                  >
                    EN
                  </span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <!-- 主要内容区域 -->
    <div class="container-fluid px-0 content-area">
      <!-- <router-view></router-view> -->
      <!-- 关于我们 -->
      <div
        id="jumpabout"
        class="about_box d-flex flex-column align-items-center justify-content-around"
      >
        <div class="about_box_content text-light row d-flex align-items-center">
          <div class="col-lg-5 pl-0 pr-0">
            <img
              class="img-fluid"
              src="../../assets/images/imgs/Group 3873.png"
              alt=""
            />
          </div>
          <div style="max-width: 804px">
            <p class="introduction_title">
              {{ $t(`homeAbout.title`) }}
            </p>
            <p
              class="text-left"
              style="font-size: 20px"
              v-if="$i18n.locale == 'zh'"
            >
              {{ $t(`homeAbout.briefIntroduction`) }}
            </p>
            <p class="text-left" style="word-break: break-all" v-else>
              {{ $t(`homeAbout.briefIntroduction`) }}
            </p>
          </div>
        </div>
        <div
          class="about_box_service d-flex justify-content-center align-items-center"
        >
          <div class="left_rectangle col-md-2 pl-0"></div>
          <img
            src="../../assets/images/imgs/stack-fill.png"
            alt=""
            class="img-fluid ml-2 mr-2"
          />
          <div class="service_title mr-2">{{ $t(`homeAbout.structure`) }}</div>
          <div class="right_rectangle col-md-2 pl-0"></div>
        </div>
        <div class="six_box row col-md-8 align-items-center">
          <div
            class="six_item col-lg-2 d-flex flex-column align-items-center justify-content-around"
            v-for="(item, index) in aboutList"
            :key="index"
          >
            <img class="img-fluid" :src="item.url" />
            <span>{{ $t(`homeAbout.${item.title}`) }}</span>
          </div>
        </div>
      </div>
      <!-- 合作模式 -->
      <div
        class="work_index d-flex flex-column align-items-center justify-content-center"
        id="jumpwork"
      >
        <div
          class="work_index_top d-flex flex-column align-items-center justify-content-center"
        >
          <div>
            <img
              src="../../assets/images/imgs/service-fill.png"
              alt="work_index"
            />
            {{ $t(`homeWork.title`) }}
          </div>
          <div class="work_line"></div>
        </div>
        <div
          class="work_index_bottom row mr-0 ml-0 d-flex flex-column align-items-center justify-content-center"
        >
          <div
            class="bottom_item col-lg-12 d-flex align-items-center justify-content-around"
            v-for="(item, index) in workList"
            :key="index"
          >
            <div class="col-4 d-flex align-items-center justify-content-center">
              <img :src="item.url" />
            </div>
            <div class="col-8">
              <p class="step">{{ $t(`homeWork.${item.title}`) }}</p>
              <p class="introduce">
                {{ $t(`homeWork.${item.synopsis}`) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 资源 -->
      <div class="my-resource" id="jumpresource">
        <div class="container">
          <div class="font-weight-bold my-resource-title pt-2">
            <img src="@/assets/images/imgs/job-img.png" alt="" />
            {{ $t(`homeResource.title`) }}
          </div>
          <div class="row py-5">
            <div class="col-lg-4 d-flex justify-content-center mb-2">
              <div class="my-resource-card py-3 pr-3">
                <ul>
                  <li
                    class="text-left mb-1"
                    v-for="(name, ind) in lists1"
                    :key="ind"
                  >
                    {{ $t(`homeResource.${name}`) }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 d-flex justify-content-center mb-2">
              <div class="my-resource-card py-3 pr-3">
                <ul>
                  <li
                    class="text-left mb-1"
                    v-for="(name, ind) in lists2"
                    :key="ind"
                  >
                    {{ $t(`homeResource.${name}`) }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 d-flex justify-content-center mb-2">
              <div class="my-resource-card py-3 pr-3">
                <ul>
                  <li
                    class="text-left mb-1"
                    v-for="(name, ind) in lists3"
                    :key="ind"
                  >
                    {{ $t(`homeResource.${name}`) }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 关于我们 -->
      <div class="my-contract" id="jumpcontact" v-if="$i18n.locale == 'en'">
        <div class="divide-gap"></div>
        <div
          class="d-flex flex-column justify-content-center align-items-center mt-3"
        >
          <div class="font-weight-bold my-contract-title mt-5 mb-3">
            We sincerely invite you to work with Elitego Allot!
          </div>
          <div class="container my-contract-content">
            <div class="my-contract-content_sub text-left pl-1 mt-4">
              <svg-icon icon-class="chat-icon" class="sub-svg" /> Contact Us:
            </div>
            <div class="row">
              <div
                class="col-md-6 text-left mt-4"
                v-for="(user, ind) in dataListEn"
                :key="ind"
              >
                <div class="user-name mb-2">
                  <span>{{ user.name }}</span>
                </div>
                <div>
                  <svg-icon icon-class="tel-icon" />
                  Tel：<span>{{ user.tel }}</span>
                </div>
                <div>
                  <svg-icon icon-class="mail-icon" />
                  Mail：<a
                    :href="`mailto:${user.mail}`"
                    class="text-decoration-none user-mail"
                    >{{ user.mail }}</a
                  >
                </div>
                <div class="back-links">
                  <a
                    class="text-decoration-none back-links_linkedin"
                    :href="user.linkedin"
                    target="_blank"
                    ><svg-icon icon-class="linkedin-icon" /> LinkedIn</a
                  >
                  <span> | </span>
                  <a
                    class="text-decoration-none back-links_facebook"
                    :href="user.facebook"
                    target="_blank"
                    ><svg-icon icon-class="facebook-icon" /> Facebook</a
                  >
                </div>
              </div>
            </div>
            <div class="my-contract-content_sub text-left pl-1 mt-4">
              <svg-icon icon-class="point-icon" class="sub-svg" /> Our address:
            </div>
            <div class="row mb-2 mt-4 d-flex align-items-center">
              <div class="col-md-7 text-left">
                <span>
                  Room 3-178, Floor 1-2, Building 14, No. 1, Dehui Road, Haidian
                  District, Beijing, China
                </span>
              </div>
              <div class="col-md-5 mb-2">
                <img src="../../assets/images/icons/image.png" />
              </div>
            </div>
            <div class="row mb-2 d-flex align-items-center">
              <div class="col-md-7 text-left">
                <span
                  >Room 1601, Building 1, Juheng Science and Technology Park,
                  No. 20, Yueyuan Road, Yuehu Street, Kaifu District, Changsha
                  City, Hunan Province, China
                </span>
              </div>
              <div class="col-md-5 mb-2">
                <img src="../../assets/images/icons/image (1).png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-contract" id="jumpcontact" v-else>
        <div class="divide-gap"></div>
        <div
          class="d-flex flex-column justify-content-center align-items-center mt-3"
        >
          <div class="container my-contract-content">
            <div class="my-contract-content_sub text-left pl-1 mt-4">
              <svg-icon icon-class="send-plane-fill" class="sub-svg" />
              <span style="font-weight: 600">联系我们</span>
            </div>
            <div class="row">
              <div
                class="col-md-12 text-left mt-4"
                v-for="(user, ind) in dataListZh"
                :key="ind"
              >
                <p>
                  <svg-icon icon-class="tel-icon" />
                  联系电话：<span>{{ user.tel }}</span>
                </p>
                <p>
                  <svg-icon icon-class="wechat-2-line" />
                  微信：<span>{{ user.WeChat }}</span>
                </p>
                <p>
                  <svg-icon icon-class="mail-icon" />
                  邮箱：
                  <a
                    :href="`mailto:${user.mail}`"
                    class="text-decoration-none user-mail"
                  >
                    {{ user.mail }}
                  </a>
                </p>
              </div>
            </div>
            <div class="my-contract-content_sub text-left pl-1 mt-4">
              <svg-icon icon-class="map-pin-range-fill" class="sub-svg" />
              <span style="font-weight: 600">公司地址</span>
            </div>
            <div class="row mb-2 mt-4 d-flex align-items-center">
              <div class="col-md-7 text-left">
                <span>北京市海淀区德惠路1号院14号楼1至2层3-178</span>
              </div>
              <div class="col-md-5 mb-2">
                <baidu-map
                  id="allmap"
                  :center="{ lng: 116.274221, lat: 40.046215 }"
                  :zoom="12"
                  :scroll-wheel-zoom="true"
                >
                  <!-- 添加标记点 -->
                  <bm-marker
                    :position="{ lng: 116.274221, lat: 40.046215 }"
                    :icon="{
                      url: require('../../assets/images/icons/map-pin-2-fill.png'),
                      size: { width: 32, height: 32 },
                    }"
                  ></bm-marker>
                </baidu-map>
              </div>
            </div>
            <div class="row mb-2 d-flex align-items-center">
              <div class="col-md-7 text-left">
                <span>
                  中国湖南省长沙市开福区月湖街道匍园路20号聚恒科技园1栋1601房
                </span>
              </div>
              <div class="col-md-5 mb-2">
                <baidu-map
                  id="allmap2"
                  :center="{ lng: 113.036877, lat: 28.236843 }"
                  :zoom="12"
                  :scroll-wheel-zoom="true"
                >
                  <!-- 添加标记点 -->
                  <bm-marker
                    :position="{ lng: 113.036877, lat: 28.236843 }"
                    :icon="{
                      url: require('../../assets/images/icons/map-pin-2-fill.png'),
                      size: { width: 32, height: 32 },
                    }"
                  ></bm-marker>
                </baidu-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <div class="container-fluid mt-auto">
      <footer-index />
    </div>
  </div>
</template>
<script>
import FooterIndex from "@/components/Footer/index.vue";
import {
  navList,
  aboutList,
  workList,
  datas1,
  datas2,
  datas3,
  contactListEn,
  contactListZh,
} from "../homeJs/index.js";
export default {
  name: "HomeIndex", // 修改组件名为多词形式
  components: { FooterIndex },
  data() {
    return {
      currentNavInd: 1,
      navList: navList,
      aboutList: aboutList,
      workList: workList,
      lists1: datas1,
      lists2: datas2,
      lists3: datas3,
      dataListEn: contactListEn,
      dataListZh: contactListZh,
      mapBJ: null, // 地图容器
    };
  },
  created() {},
  methods: {
    loadView(nav) {
      this.currentNavInd = nav.id;
    },
    // 中文切换
    changeLangZh() {
      this.$i18n.locale = "zh";
    },
    // 英文切换
    changeLangEn() {
      this.$i18n.locale = "en";
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
$primaryColor: #17757a;
/* 样式部分可以根据需要添加 */
.my-home-page {
  height: 100vh;
}
.my-head {
  user-select: none;
  background-color: #fff !important;
  padding: 0 6%;
  .my-head-logo {
    font-size: 36px;
    color: #17757a !important;
  }
  &-language {
    .global-icon {
      font-size: 24px;
    }
  }
  &-collapse {
    height: inherit;
    margin-left: 10%;

    .navbar-nav {
      height: inherit;
      line-height: 80px;
      .nav-link {
        padding-top: 0;
        padding-bottom: 0;
        position: relative;
        color: #333333;
        font-weight: 400;
        white-space: nowrap;
      }
      .active {
        .nav-link {
          color: #17757a;
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            display: inline-block;
            width: 60%;
            height: 3px;
            background-color: #17757a;
          }
        }
      }
    }
  }
}
.about_box {
  padding: 80px 0 0 0;
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
  &_content {
    width: 100%;
    min-height: 285px;
    margin-bottom: 20px;
    background: rgb(48, 158, 164);
    .introduction_title {
      font-size: 32px;
      font-weight: 700;
      color: #ffffff;
      text-align: left;
    }
  }
  &_service {
    width: 100%;
    margin-bottom: 20px;
    .left_rectangle {
      height: 7px;
      background: linear-gradient(
        90deg,
        #ffffff 0%,
        rgba(229, 252, 254, 0) 26.5%,
        #17757a 100%
      );
    }
    .right_rectangle {
      height: 7px;
      background: linear-gradient(
        90deg,
        #17757a 0%,
        rgba(229, 252, 254, 0) 73.5%,
        #ffffff 100%
      );
    }
    .service_title {
      font-size: 36px;
      font-weight: 700;
      color: #17757a;
    }
  }
  .six_box {
    width: 100%;
    min-height: 281px;
    .six_item {
      height: 150px;
      width: 150px;
      img {
        width: 88px;
        height: 88px;
      }
    }
  }
}
.work_index {
  width: 100%;
  background: #ffffff;
  &_top {
    font-size: 36px;
    font-weight: 700;
    color: #17757a;
    margin-bottom: 20px;
    .work_line {
      width: 60px;
      height: 3px;
      background: #17757a;
    }
  }
  &_bottom {
    margin-bottom: 40px;
    .bottom_item {
      min-height: 115px;
      width: 100%;
      text-align: left;
      margin-bottom: 20px;
      min-width: 420px;
      img {
        width: 88px;
        height: 88px;
      }
      .step {
        font-size: 24px;
        font-weight: 600;
        color: #17757a;
      }
      .introduce {
        color: #999999;
        font-weight: 600;
      }
    }
    .bottom_item:hover {
      /* 鼠标移入时的样式 */
      box-shadow: 0px 0px 12px #efefef; /* 添加阴影 */
      border-radius: 4px;
    }
  }
}
.my-resource {
  background-color: #f5f7fa;
  .my-resource-title {
    font-size: 36px;
    color: $primaryColor;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-20%);
      display: block;
      width: 60px;
      height: 3px;
      background-color: $primaryColor;
    }
  }
  .my-resource-card {
    min-height: 740px;
    width: 380px;
    border: 1px solid $primaryColor;
    background-color: rgba(72, 116, 203, 0.05);
    color: $primaryColor;
    font-size: 16px;
    font-weight: 500;
    border-radius: 8px;
    pointer-events: default;
    li:last-child {
      letter-spacing: 2px;
    }
    &:hover {
      background-color: rgba(72, 116, 203, 0.1);
    }
  }
}
.my-contract {
  background-color: #fff;
  min-height: 650px;
  .divide-gap {
    background-color: #f5f7fa;
    width: 100%;
    height: 16px;
  }
  .sub-svg {
    font-size: 20px;
  }
  .my-contract-title {
    font-size: 28px;
    color: $primaryColor;
  }
  .my-contract-content {
    max-width: 1000px;
    font-size: 16px;
    color: #333;
    .back-links {
      color: $primaryColor;
      &_linkedin {
        color: $primaryColor;
        border-bottom: 1px solid $primaryColor;
      }
      &_facebook {
        color: $primaryColor;
        border-bottom: 1px solid $primaryColor;
      }
    }
    .user-name {
      font-size: 18px;
      font-weight: 550;
    }
    .user-mail {
      color: #333;
      border-bottom: 1px solid #333;
    }
    &_sub {
      font-size: 20px;
      line-height: 28px;
      position: relative;
      width: inherit;
      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        display: block;
        width: 108px;
        height: 6px;
        border-radius: 8px;
        background: linear-gradient(
          90deg,
          #17757a 0%,
          rgba(23, 117, 122, 0) 100%
        );
      }
    }
  }
}
.textarea {
  color: $primaryColor;
}
.footer-qrcode_contact {
  width: 100px;
  height: 40px;
  background-color: $primaryColor;
  line-height: 32px;
  font-size: 15px;
  text-align: center;
  color: #fff;
}
#allmap {
  width: 236px;
  height: 110px;
  margin: 0 auto;
}
#allmap2 {
  width: 236px;
  height: 110px;
  margin: 0 auto;
}
.en_title {
  font-size: 20px;
  font-weight: 700;
  color: $primaryColor;
}
</style>
